import { useState } from "react";
import { api } from "@/lib/kfmApi";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// Reading-level toggle (Simple / Standard). Zone A — FREE, unmetered. Regenerates the
// study commentary at the chosen level in the background, then reloads the session.
export default function ReadingLevelToggle({ session, onReload }) {
  const current = session.reading_level === "simple" ? "simple" : "standard";
  const [busy, setBusy] = useState("");

  const choose = async (level) => {
    if (level === current || busy) return;
    setBusy(level);
    try {
      await api.post(`/study/sessions/${session.id}/reading-level`, { reading_level: level });
      // Poll until the regenerated study is ready, then reload the session.
      for (let i = 0; i < 30; i++) {
        await new Promise((r) => setTimeout(r, 2500));
        const { data } = await api.get(`/study/sessions/${session.id}`);
        if (data.status === "ready" && data.reading_level === level) {
          onReload?.(data);
          break;
        }
      }
    } catch (e) {
      toast.error("Couldn't switch reading level right now. Please try again.");
    }
    setBusy("");
  };

  const Opt = ({ level, label }) => {
    const active = current === level;
    return (
      <button
        type="button"
        data-testid={`reading-level-${level}`}
        onClick={() => choose(level)}
        disabled={!!busy}
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-full transition-colors
          ${active ? "bg-[#00E5FF] text-[#07090E]" : "text-slate-400 hover:bg-[#141B29]"}`}
      >
        {busy === level && <Loader2 className="w-3.5 h-3.5 animate-spin" />}
        {label}
      </button>
    );
  };

  return (
    <div className="inline-flex items-center gap-1 rounded-full bg-[#0E131F] border border-[#29344D] p-1" data-testid="reading-level-toggle">
      <span className="text-[11px] uppercase tracking-widest text-slate-500 px-2">Reading level</span>
      <Opt level="simple" label="Simple" />
      <Opt level="standard" label="Standard" />
    </div>
  );
}
